import React from 'react';
import { FDLozenge, FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { dataAttrs } from 'Helpers/Testing';

function ExpenseStepHeader({ resource }) {
  return (
    <FDStack direction={'column'} spacing={4} alignItems={'center'}>
      <FDLozenge label={resource.attr('stepText')} color={'info'} size={'lg'} {...dataAttrs('step-text-lozenge')} />
      <Text
        variant="h1"
        color="primary"
        weight={'medium'}
        align={'center'}
        value={resource.attr('title')}
      />
      <Text
        variant="h5"
        color="primaryGray"
        weight={'medium'}
        align={'center'}
        value={resource.attr('subtitle')}
        lineHeight={'small'}
      />
    </FDStack>
  );
}

ExpenseStepHeader.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

ExpenseStepHeader.defaultProps = {
};

export default ExpenseStepHeader;
